import React from 'react';
import { motion } from 'framer-motion';
import { Clock, TrendingDown } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-cream py-20 px-6" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-teal/10 text-center relative overflow-hidden" data-id="element-152">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-teal via-copper to-teal" data-id="element-153"></div>

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-8" data-id="element-154">
            En solo 7 días aplicando el Protocolo SOS...
          </h2>

          <p className="text-xl text-gray-600 mb-10 italic" data-id="element-155">
            "Dejarás de tener miedo a salir de casa."
          </p>

          <div className="grid md:grid-cols-2 gap-8 items-center justify-center" data-id="element-156">
            <div className="flex flex-col items-center p-6 bg-red-50 rounded-2xl border border-red-100" data-id="element-157">
              <Clock className="w-10 h-10 text-red-400 mb-4" data-id="element-158" />
              <p className="text-sm text-gray-500 uppercase tracking-wide font-semibold mb-2" data-id="element-159">
                ANTES
              </p>
              <p className="text-2xl font-bold text-red-900" data-id="element-160">45 minutos</p>
              <p className="text-red-700 mt-2" data-id="element-161">de llanto y desborde</p>
            </div>

            <div className="hidden md:flex justify-center absolute left-1/2 -translate-x-1/2" data-id="element-162">
              <TrendingDown className="w-12 h-12 text-copper" data-id="element-163" />
            </div>

            <div className="flex flex-col items-center p-6 bg-teal/10 rounded-2xl border border-teal/20" data-id="element-164">
              <Clock className="w-10 h-10 text-teal mb-4" data-id="element-165" />
              <p className="text-sm text-teal-700 uppercase tracking-wide font-semibold mb-2" data-id="element-166">
                DESPUÉS
              </p>
              <p className="text-2xl font-bold text-teal-900" data-id="element-167">&lt; 5 minutos</p>
              <p className="text-teal-800 mt-2" data-id="element-168">de regulación tranquila</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}